    <template>
    <transition name="fade">
        <div v-if="alert_show" class="absolute w-full h-full flex flex-1 items-center z-40" @keyup.esc="alert_close" tabindex="0">
            <div class="absolute w-full h-full bg-black opacity-50"></div>
            <div class="content">
                <h1 v-if="title">{{title}}</h1>
                <p v-if="message" class="text-xs">{{message}}</p>
                <div class="-mx-4 -mb-4 mt-3 border-t border-gray-700 flex">
                    <div @click="alert_confirm" class="alert-confirm">Потвърди</div>
                    <div @click="alert_close" class="alert-cancel">Откажи</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: 'Alert',
        computed: {
            ...mapGetters('alert', [
                'message', 'title','alert_show'
            ])
        },
        watch:{
            alert_show(){
                if (this.alert_show === false) {
                    window.removeEventListener("keyup", this.onEscapeKeyUp);
                } else {
                    window.addEventListener("keyup", this.onEscapeKeyUp);
                }
            }

        },
        methods: {
            ...mapMutations('alert', [
                'alert_confirm', 'alert_close'
            ]),
            onEscapeKeyUp (event) {
                if (event.which === 27) {
                    this.alert_close();
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: all 0.5s;
        .content {
            transition: all 0.5s;
        }
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        .content{
            opacity: 0 !important;
            transform: translateY(-100px) !important;
        }
        opacity: 0 !important;
    }

    .content{
        @apply bg-black text-center m-auto z-10 p-4 rounded;
        @screen md{
            @apply w-1/4;
        }
    }

    .alert-confirm{
        @apply cursor-pointer text-center w-1/2 p-2 border-r border-dark-100 rounded-bl;
        &:hover {
            @apply bg-dark-100;
        }
    }

    .alert-cancel{
        @apply text-center w-1/2 p-2 rounded-br cursor-pointer;
        &:hover{
            @apply bg-dark-100;
        }
    }

</style>